import React from 'react';
import { Typography } from '@waglabs/typography';
export const ModalSubheadingText = (props) => (React.createElement(Typography, Object.assign({ color: "#474747", lineHeight: ['20px', '28px'], m: 0, maxWidth: ['148px', '192px'] }, props)));
